import type { BankDataInfo } from 'refunds/types/refundData'

export const formatBankAccount = (bankDataInfo: BankDataInfo) => {
	const { cuentaCompleta, bankAccount, blz, sucursal, innBanco, bicBanco } =
		bankDataInfo

	const fields = !cuentaCompleta
		? [blz, sucursal, innBanco, bicBanco].filter((field) => !!field)
		: []

	if (bankAccount) {
		fields.push(bankAccount)
	}

	return fields.join(' ')
}
